import React, { useEffect } from "react";

import styles from "./style.module.css";

import Card from "./card";
import { API_URL } from "../../../../api";
import { useCookies } from "../../../../hooks/useCookies";

export default function ProfileDetailsPreview({ activeTabs }) {
  const cookies = useCookies();

  const [loading, setLoading] = React.useState(false);
  const [profile, setProfile] = React.useState({});
  const userId = cookies.getCookie("userId");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${API_URL}customer/user/profile/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.getCookie("token")}`,
            },
          }
        );
        const data = await response.json();
        if (!data) return;

        if (response.ok) {
          setProfile(data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [window.location.pathname]);

  return (
    <div className={styles.container}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Card {...profile} show activeTabs={activeTabs} />
      )}
    </div>
  );
}
